/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

export const V3ArticleCardAnchorWrapper = styled.a.attrs({
  className: 'cpds-link-ga',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    textDecoration,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: block;
      color: ${checkValue(color) ? color : token?.v3_card_title_color};
      ${checkValue(textDecoration) && `text-decoration: ${textDecoration} !important;`}
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const V3ArticleCardTagContainer = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      align-items: center;
      gap: ${token?.spacing?.space_12};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;
